<template lang="pug">
.beforeLogin
  .beforeLogin__btnArea
    button.filterBtn(@click="scroll('newInfo')") {{ $t('lpTop.newInfo') }} 
    button.filterBtn(@click="scroll('whatBraveFrontier')") {{ $t('lpTop.whatBraveFrontierHead') }}
    button.filterBtn(@click="scroll('newExperience')") {{ $t('lpTop.experienceHead') }}
    button.filterBtn(@click="scroll('gameBegining')") {{ $t('lpTop.beginngGame') }}

  .beforeLogin__newInfo(id="newInfo")
    h2.beforeLogin__newInfo__header {{ $t('lpTop.newInfo') }}
    div(v-if="isLoading")
      PickupBannerSwipe( :bannerData='banners')
    .beforeLogin__newInfo__loading(v-else)
      fa-icon(:icon="['fal', 'spinner']" spin size="3x")
    .beforeLogin__sns__header
      h2 {{ $t('lpTop.snsHeader') }}
  
  .beforeLogin__partition

  .beforeLogin__bg(:style='bg1' id="whatBraveFrontier")
    .beforeLogin__whatBraveFrontier
      .beforeLogin__whatBraveFrontier__header
        h2 {{ $t('lpTop.whatBraveFrontierHead')}}
      .beforeLogin__whatBraveFrontier__movie
        .beforeLogin__whatBraveFrontier__movie--iframe
          <iframe src="https://www.youtube.com/embed/cva1QgAEsic" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"  allowfullscreen></iframe>
      .beforeLogin__whatBraveFrontier__text
        nl2br(tag="p" :text="$t('lpTop.whatBraveFrontier')")

    .beforeLogin__mainTopic
      .beforeLogin__mainTopic_grid
        .beforeLogin__mainTopic_grid__title 
          p {{$t('howtoplay.about.subtitle.1')}}
          .beforeLogin__mainTopic_grid__title__right 
            p {{$t('howtoplay.about.subtitle.1_lang')}}

      .beforeLogin__mainTopic_grid__titile
        nl2br(tag='p' :text="$t('howtoplay.about.text.1')")

  .beforeLogin__partition(id="newExperience")

  .beforeLogin__gamePoint
    h2.beforeLogin__gamePoint__header {{ $t('lpTop.experienceHead') }}
    .beforeLogin__gamePoint__area__text--mobile
      h3.beforeLogin__gamePoint__area__text--header-top {{ $t('howtoplay.about.subtitle.2') }}
    .beforeLogin__gamePoint__area
      .beforeLogin__gamePoint__area__image(@click="openUnitModal()")
        img(:src="$env.staticUrl + '/lp/img/about/delta.jpg'")
        p {{ $t('howtoplay.about.image.unit') }}
      .beforeLogin__gamePoint__area__text
        div
          h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.2') }}
          nl2br(tag="p" :text="$t('howtoplay.about.text.2')")
      .beforeLogin__gamePoint__area__text--mobile
        div
          nl2br(tag="p" :text="$t('howtoplay.about.text.2')")

    .beforeLogin__gamePoint__area__text--mobile
      h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.3') }}
    .beforeLogin__gamePoint__area
      .beforeLogin__gamePoint__area__text
        div
          h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.3') }}
          nl2br(tag="p" :text="$t('howtoplay.about.text.3')")
      .beforeLogin__gamePoint__area__image(@click="openSphereModal()")
        img(:src="$env.staticUrl + '/lp/img/about/6eiyu_mojinasi.jpg'")
        p {{ $t('howtoplay.about.image.sphere') }}
      .beforeLogin__gamePoint__area__text--mobile
        div
          nl2br(tag="p" :text="$t('howtoplay.about.text.3')")          

    .beforeLogin__gamePoint__area__text--mobile
      h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.4') }}
    .beforeLogin__gamePoint__area
      .beforeLogin__gamePoint__area__image(@click="openEconomicsModal")
        img(:src="$env.staticUrl + '/lp/img/about/rank_demon_wcc.jpg'")
        p {{ $t('howtoplay.about.image.economics') }}
      .beforeLogin__gamePoint__area__text
        div
          h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.4') }}
          nl2br(tag="p" :text="$t('howtoplay.about.text.4')")
      .beforeLogin__gamePoint__area__text--mobile
        div
          nl2br(tag="p" :text="$t('howtoplay.about.text.4')")
    
    .beforeLogin__gamePoint__area__text--mobile
      h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.5') }}
    .beforeLogin__gamePoint__area
      .beforeLogin__gamePoint__area__text
        div
          h3.beforeLogin__gamePoint__area__text--header {{ $t('howtoplay.about.subtitle.5') }}
          nl2br(tag="p" :text="$t('howtoplay.about.text.5')")
      .beforeLogin__gamePoint__area__image(@click="openTwoGodModal()")
        img(:src="$env.staticUrl + '/lp/img/about/s1_ao.jpg'")
        p {{ $t('howtoplay.about.image.twoGod') }} 
      .beforeLogin__gamePoint__area__text--mobile
        div
          nl2br(tag="p" :text="$t('howtoplay.about.text.5')")        

  .beforeLogin__partition(id="gameBegining")

  .beforeLogin__gameBegining
    h2.beforeLogin__gameBegining__header {{ $t('lpTop.beginngGame') }}
    .beforeLogin__gameBegining__keyText
      nl2br(tag="p" :text="$t('howtoplay.installWalletApp')")

    .beforeLogin__gameBegining__walletBox
      .beforeLogin__gameBegining__walletStation
        .beforeLogin__gameBegining__walletStationBox01
          .beforeLogin__gameBegining__device
            span {{$t('howtoplay.requirements.device.pc')}} /
            span {{$t('howtoplay.requirements.device.sp')}}
            span
              fa-icon(:icon="['fas', 'desktop']")
          .beforeLogin__gameBegining__logoBox
            img(:src="$env.staticUrl+'/lp/img/metamask.png'")
          a(:href="onMetaMask()")
            p.beforeLogin__gameBegining__logoSite__meta {{$t('howtoplay.officialSite')}}
        .beforeLogin__gameBegining__walletStationBox01
          .beforeLogin__gameBegining__device
            span {{$t('howtoplay.requirements.device.pc')}} /
            span {{$t('howtoplay.requirements.device.sp')}}
            span
              fa-icon(:icon="['fas', 'mobile-alt']")
          .beforeLogin__gameBegining__appsBox.beforeLogin__gameBegining__go_ios_link
            .beforeLogin__gameBegining__app(style="color:#000")
              img.beforeLogin__gameBegining__walletlogo(:src="$env.staticUrl+'/lp/img/logo/i_bnr_oasyspass.png'")
              p {{$t('howtoplay.oasysPassCatchCopy')}}
              button.beforeLogin__gameBegining__link(@click="onOasysPass") {{$t('howtoplay.oasysPassLink')}}
              a(:href="onOasysPassApple()" id="gtm_oasyspass_ios")
                img.beforeLogin__gameBegining__storeapple(:src="$env.staticUrl+'/lp/img/logo/btn_apple.png'")
              a(:href="onOasysPassGoogle()" id="gtm_oasyspass_android")
                img.beforeLogin__gameBegining__storegoogle(:src="$env.staticUrl+'/lp/img/logo/btn_google.png'")
    .beforeLogin__gameBegining__contentBox
      .beforeLogin__gameBegining__contentBoxtitle {{$t('howtoplay.doTogether')}}

      .beforeLogin__gameBegining__videobox
        .beforeLogin__gameBegining__pcVideo
          p PC
          iframe(v-if="$i18n.locale=='ja'" width="300" height="180" src="https://www.youtube.com/embed/qZjUPE1TW-k" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
          iframe(v-else width="300" height="180" src="https://www.youtube.com/embed/6Gf_kRE4MJU" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)

    .beforeLogin__gameBegining__finishBox
      img(:src="$env.staticUrl+'/lp/img/i_dot_left.png'")
      div
        nl2br(tag='p' :text="$t('howtoplay.finishText')")
      img(:src="$env.staticUrl+'/lp/img/i_dot_right.png'")

  .beforeLogin__detail_modal 
    Modal(v-if="isUnitModal" @modal-close="isUnitModal = false" modalSizeSmall)
      template(slot="header")
        p {{ $t('howtoplay.about.subtitle.2') }}
      template
        img(:src="$env.staticUrl+'/lp/img/about/delta.png'")
        .detail_modal--text
          nl2br(tag="p" :text="$t('howtoplay.about.modal.unit')")    

  .beforeLogin__detail_modal 
    Modal(v-if="isSphereModal" @modal-close="isSphereModal = false" modalSizeSmall)
      template(slot="header")
        p {{ $t('howtoplay.about.subtitle.3') }}
      template
        img(:src="$env.staticUrl+'/lp/img/about/6eiyu_mojinasi.png'")
        .detail_modal--text
          nl2br(tag="p" :text="$t('howtoplay.about.modal.sphere')")    

  .beforeLogin__detail_modal 
    Modal(v-if="isEconomicsModal" @modal-close="isEconomicsModal = false" modalSizeSmall)
      template(slot="header")
        p {{ $t('howtoplay.about.subtitle.4') }}
      template
        img(:src="$env.staticUrl + '/lp/img/about/rank_demon_wcc.png'")
        .detail_modal--text
          nl2br(tag="p" :text="$t('howtoplay.about.modal.economics')")   

  .beforeLogin__detail_modal 
    Modal(v-if="isTwoGodModal" @modal-close="isTwoGodModal = false" modalSizeSmall)
      template(slot="header")
        p {{ $t('howtoplay.about.subtitle.5') }}
      template
        img(:src=" $env.staticUrl+'/lp/img/about/s1_ao.png'")
        .detail_modal--text
          nl2br(tag="p" :text="$t('howtoplay.about.modal.twoGod')")    

</template>

<script>
const TwitterFeed = () => import('@/components/molecules/TwitterFeed')
const ExternalLink = () => import('@/components/atoms/ExternalLink')
import Nl2br from 'vue-nl2br'
const LazyImage = () => import('@/components/atoms/LazyImage')
const Modal = () => import('@/components/organisms/Modal')
const PickupBannerSwipe = () => import('@/components/molecules/PickupBannerSwipe')
import BannerData from '~/static/banner/data/TopPageBannerData.json'

export default {
  components: {
    TwitterFeed,
    ExternalLink,
    Nl2br,
    LazyImage,
    Modal,
    PickupBannerSwipe,
  },
  data: () => ({
    unitsDetailModalShown: false,
    isUnitModal: false,
    isSphereModal: false,
    isEconomicsModal: false,
    isTwoGodModal: false,
    isLoading: false,
    banners: BannerData,
  }),
  computed: {
    bg1() {
      return {
        backgroundImage: `url('${this.$env.staticUrl}/lp/img/top/i_bg02.jpg')`,
      }
    },
    bg2() {
      return {
        backgroundImage: `url('${this.$env.staticUrl}/lp/img/top/i_bg_world.jpg')`,
      }
    },
    bg3() {
      return {
        backgroundImage: `url('${this.$env.staticUrl}/lp/img/top/i_line01.png')`,
      }
    },
  },
  mounted() {
    this.isLoading = true
  },
  methods: {
    onMetaMask() {
      return 'https://metamask.io/'
      window.open('https://metamask.io/')
    },
    onOasysPass() {
      this.$router.push(this.localePath('lp'))
    },
    onTokenPocketApple() {
      return 'https://apps.apple.com/us/app/bfh-app-by-tokenpocket/id1495001638?l=ja&ls=1'
      // window.open('https://apps.apple.com/us/app/bfh-app-by-tokenpocket/id1495001638?l=ja&ls=1')
    },
    onTokenPocketGoogle() {
      return 'https://play.google.com/store/apps/details?id=com.tokenpocket.bravefrontier'
      // window.open('https://play.google.com/store/apps/details?id=com.tokenpocket.bravefrontier')
    },
    onOasysPassApple() {
      return 'https://apps.apple.com/app/apple-store/id6449960854?pt=126352139&ct=lp_bfh&mt=8'
      // window.open('https://apps.apple.com/us/app/bfh-app-by-tokenpocket/id1495001638?l=ja&ls=1')
    },
    onOasysPassGoogle() {
      return 'https://play.google.com/store/apps/details?id=com.oasys_wallet.oas_app&utm_source=lp_bfh'
      // window.open('https://play.google.com/store/apps/details?id=com.tokenpocket.bravefrontier')
    },
    openUnitModal() {
      this.isUnitModal = true
    },
    openSphereModal() {
      this.isSphereModal = true
    },
    openEconomicsModal() {
      this.isEconomicsModal = true
    },
    openTwoGodModal() {
      this.isTwoGodModal = true
    },
    scroll(to) {
      let currentY = window.scrollY
      // スクロール先の調整
      const element = document.getElementById(to)
      const width = element.getBoundingClientRect().width

      if (width < 768) {
        currentY = currentY - 22
        if (to === 'whatBraveFrontier' || to === 'newExperience') currentY = currentY - 22
        else if (to === 'newInfo') currentY = currentY - 40
        const position = element.getBoundingClientRect().top + currentY
        window.scrollTo({ top: position, behavior: 'smooth' })
      } else {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.beforeLogin {
  background-color: #1d1e21;

  &__btnArea {
    padding: 1rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1rem;

    @media (min-width: $breakpoint) {
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 1.5rem;
      max-width: 1200px;
      margin: 0 auto;
      padding: 3rem 3rem 0rem 3rem;
    }

    .filterBtn {
      float: right;
      color: #fff;
      font-size: 0.8rem;
      line-height: 1;
      border: 2px solid #a88c59;
      border-radius: 50px;
      background: #435c73;
      height: 2rem;
      width: 100%;

      @media (min-width: $breakpoint) {
        font-size: 1rem;
        height: 2.5rem;
      }
    }
  }

  &__newInfo {
    padding: 0 1rem 1rem 1rem;

    @media (min-width: $breakpoint) {
      max-width: 1200px;
      margin: 0 auto;
      padding: 4rem 3rem 3rem 3rem;
    }

    &__header {
      margin-bottom: 1.5rem;

      @media (min-width: $breakpoint) {
        margin-bottom: 2rem;
      }
    }

    &__loading {
      text-align: center;
    }

    &__footer {
      text-align: right;
      text-decoration: none;
      a:hover {
        cursor: pointer;
        text-decoration: underline #74b9ff;
      }
    }
  }

  &__whatBraveFrontier {
    width: 100%;
    margin: 0 auto 3rem auto;
    padding: 2rem 1rem;
    background: #1d1e21;
    border-radius: 8px;
    text-align: justify;

    @media (min-width: $breakpoint) {
      width: 100%;
      max-width: 1000px;
      padding: 2rem;
    }

    &__header {
      margin-bottom: 1.5rem;

      @media (min-width: $breakpoint) {
        margin-bottom: 2rem;
      }
    }

    &__movie {
      margin-bottom: 1rem;
      padding: 0;
      @media (min-width: $breakpoint) {
        padding: 0 20%;
        width: 100%;
      }

      &--iframe {
        position: relative;
        overflow: hidden;
        padding-bottom: 56.25%;
        text-align: center;
        margin: 0 auto;
        iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none; /*境界線の打ち消し*/
        }
      }
    }

    &__text {
      @media (min-width: $breakpoint) {
        width: 90%;
        margin: 0 5%;
      }

      p {
        font-size: 1rem;
        opacity: 0.8;

        @media (min-width: $breakpoint) {
          font-size: 1.2rem;
        }
      }
    }

    &__footer {
      text-align: right;
      a:hover {
        cursor: pointer;
        text-decoration: underline #74b9ff;
      }
      @media (min-width: $breakpoint) {
        margin: 0 5%;
        width: 90%;
      }
    }
  }

  &__newExperience {
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    position: relative;
    display: grid;
    padding: 2rem 1rem;

    @media (min-width: $breakpoint) {
      padding: 4rem 3rem;
    }

    &__mask {
      background-color: rgba(150, 101, 109, 0.8);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    &__inner {
      width: 100%;
      z-index: 1;
      @media (min-width: $breakpoint) {
        max-width: 1200px;
        margin: 0 auto;
      }
    }

    &__header {
      z-index: 1;
      margin-bottom: 1rem;

      @media (min-width: $breakpoint) {
        margin-bottom: 2rem;
      }
    }

    &__content {
      display: grid;
      grid-template-columns: initial;
      grid-gap: 1rem;

      @media (min-width: $breakpoint) {
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 1rem;
      }

      &__item {
        z-index: 1;
        background: #1d1e21;
        padding: 2rem;
        border-radius: 10px;
        display: grid;
        grid-gap: 2rem;
        font-size: 1.1rem;
        font-weight: bold;
        cursor: pointer;
        @media (min-width: $breakpoint) {
          padding: 1rem;
        }

        span {
          color: #1cdbb5;
        }

        &:hover {
          background: rgba(29, 30, 33, 0.7);
          //color: #000000;
          cursor: pointer;
        }
      }
    }
  }

  &__gameBegining {
    padding: 2rem 1rem;

    @media (min-width: $breakpoint) {
      margin: 0 auto;
      padding: 3rem 3rem 1rem 3rem;
      max-width: 1200px;
    }

    &__header {
      margin-bottom: 1.5rem;

      @media (min-width: $breakpoint) {
        margin-bottom: 2rem;
      }
    }

    &__keyText {
      z-index: 3;
      position: relative;
      width: 100%;
      text-align: center;
      margin: 0 auto;
      color: #fff;
      font-size: 1rem;
      text-shadow: 1px 1px 2px #000;
      @media (min-width: $breakpoint) {
        font-size: 1.5rem;
      }
    }
    &__walletBox {
      z-index: 3;
      position: relative;
      width: 22rem;
      margin: 0 auto;
      margin-bottom: 2rem;
      margin-top: 2rem;
      min-height: 15rem;
      @media (min-width: 768px) {
        width: 95%;
        max-width: 750px;
        margin-bottom: 3rem;
      }
    }
    &__walletStation {
      text-align: center;
      @media (min-width: 768px) {
        display: flex;
        justify-content: space-between;
        margin: 30px;
      }
    }
    &__walletStationBox01,
    &__walletStationBox02 {
      padding: 1rem;
      margin-top: 1rem;
      background: rgba(255, 255, 255, 0.8);
      border: 6px solid #ffffff;
      box-sizing: border-box;
      border-radius: 20px;
      color: #000;
      width: 22rem;
    }

    &__walletStationBox01 {
      @media (min-width: 768px) {
        width: 16rem;
      }
    }

    &__walletStationBox02 {
      @media (min-width: 768px) {
        width: calc(100% - 17rem);
      }
    }

    &__contentBox {
      z-index: 3;
      position: relative;
      width: 22rem;
      min-height: 10rem;
      text-align: center;
      color: #435c73 !important;
      margin: 0 auto;
      margin-bottom: 2rem;
      padding: 1rem;
      background: rgba(255, 255, 255, 0.8);
      border: 6px solid #ffffff;
      box-sizing: border-box;
      border-radius: 20px;
      @media (min-width: 768px) {
        width: 95%;
        max-width: 750px;
        margin-bottom: 3rem;
      }
    }

    &__contentBox,
    &__contentBoxtitle {
      border-bottom: 2px solid #435c73;
      font-weight: bold;
      padding-bottom: 1rem;
      @media (min-width: 768px) {
        font-size: 1.25rem;
      }
    }
    &__device {
      border-radius: 1.25rem;
      background: #fff;
      color: #435c73;
      min-width: 3.125rem;
      padding: 0.5rem;
      margin-bottom: 0.5rem;
    }

    &__logoSite__meta {
      background: #435c73;
      border-radius: 0.25rem;
      text-align: center;
      color: #fff;
      padding: 0.5rem;
    }

    &__logoBox {
      margin: 2rem 1rem;
      @media (min-width: 768px) {
        margin: 6rem 0;
      }
    }

    &__appsBox {
      @media (min-width: 768px) {
        display: flex;
        justify-content: space-between;
      }
    }

    &__appsBox &__app p {
      font-size: 0.875rem;
      margin: 0.5rem 0 0;
      text-align: left;
      @media (min-width: 768px) {
        font-size: 0.75rem;
      }
    }

    &__app {
      padding: 1rem 0;
      @media (min-width: 768px) {
        padding: 1rem 0.5rem 0 0;
        //width: 50%;
      }
    }

    &__app:last-child {
      border-top: 2px solid #fff;
      padding-bottom: 0;
      @media (min-width: 768px) {
        border-top: none;
        //border-left: 2px solid #fff;
        padding: 1rem 0 0 0.5rem;
      }
    }

    &__app img.beforeLogin__gameBegining__walletlogo {
      width: 50%;
      @media (min-width: 768px) {
        width: 6rem;
      }
    }

    &__app button.beforeLogin__gameBegining__link {
      background: #435c73;
      border-radius: 0.25rem;
      text-align: center;
      color: #fff;
      padding: 0.5rem;
    }

    &__storeapple,
    &__storegoogle {
      width: 12rem;
      margin: 0.5rem 0 0;
      @media (min-width: 768px) {
        width: 8rem;
      }
    }
    &__pcVideo {
      margin: 1rem 0 0;
    }

    &__pcVideo p {
      margin: 0 auto 0.5rem;
      width: 50%;
      background-color: #f50289;
      color: #fff;
    }

    &__finishBox {
      z-index: 3;
      position: relative;
      color: #fff;
      font-size: 1.5rem;
      font-weight: bold;
      text-shadow: 1px 1px 2px #000;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 2rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      @media (min-width: 768px) {
        width: 40.625rem;
      }
    }

    &__finishBox img {
      display: none;
      @media (min-width: 768px) {
        display: block;
      }
    }
  }

  &__detail_modal {
    text-align: center;
    font-weight: bold;
    span {
      color: #1cdbb5;
    }
    &--text {
      margin-top: 1rem;
    }
  }

  &__partition {
    height: 10px;
    background-color: #1cdbb5;
  }

  &__sns {
    &__header {
      text-align: center;
      margin: 1rem 0;
    }
  }

  &__bg {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    padding: 3rem 1rem;
    @media (min-width: $breakpoint) {
      padding: 3rem;
    }
  }

  &__gamePoint {
    background-color: #1d1e21 !important;
    padding: 2rem 1rem;

    @media (min-width: $breakpoint) {
      max-width: 1200px;
      margin: 0 auto;
      padding: 3rem;
    }

    &__header {
      margin-bottom: 1rem;

      @media (min-width: $breakpoint) {
        margin-bottom: 2rem;
      }
    }

    &__area {
      display: grid;
      grid-template-columns: initial;
      grid-gap: 0;

      @media (min-width: $breakpoint) {
        margin: 4rem 0;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 4rem;
      }

      &__text {
        align-items: center;
        display: none;
        @media (min-width: $breakpoint) {
          display: flex;
        }
        &--header-top {
          color: #1cdbb5;
          font-size: 1.25rem;
          margin-top: 0;
          margin-bottom: 0;
          @media (min-width: $breakpoint) {
            font-size: 1.5rem;
            margin-top: 0;
            margin-bottom: 1.5rem;
          }
        }

        &--header {
          color: #1cdbb5;
          font-size: 1.25rem;
          margin-top: 4rem;
          margin-bottom: 0;
          @media (min-width: $breakpoint) {
            font-size: 1.5rem;
            margin-top: 0;
            margin-bottom: 1.5rem;
          }
        }

        p {
          opacity: 0.8;
        }

        &--mobile {
          display: flex;
          padding: 0 1rem;
          @media (min-width: $breakpoint) {
            display: none;
          }
        }
      }

      &__image {
        // background: rgba(255, 255, 255, 0.8);
        padding: 1rem;
        border-radius: 10px;
        color: #ffffff;
        font-size: 1.1rem;
        text-shadow: 1px 1px 1px rgba(248, 244, 244, 0.81);
        //font-weight: bold;
        // border: 6px solid #FFFFFF;
        @media (min-width: $breakpoint) {
          padding: 1rem;
        }
        span {
          color: #1cdbb5;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.7);
          color: #000000;
          cursor: pointer;
        }
      }
    }
  }

  &__mainTopic {
    // z-index: 3;
    // position: relative;

    width: 100%;
    max-width: 1000px;

    margin: 0 auto;
    padding: 1rem;

    background: rgba(67, 92, 115, 0.7);
    border-radius: 20px;
    text-shadow: 1px 2px 1px rgba(0, 0, 0, 0.5);

    @media (min-width: $breakpoint) {
      padding: 1rem;
    }

    &_grid {
      &__title {
        padding: 0 1rem;
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
        @media (min-width: 768px) {
          padding: 0 5rem;
          grid-row: 1 / 2;
          grid-column: 1 / 2;
          font-size: 1.875rem;
          margin-bottom: 1rem;
        }
        &__right {
          text-align: right;
          opacity: 0.7;
          margin-top: -10px;
        }
      }
      &__text {
        line-height: 1.2;
        margin-bottom: 1rem;
        @media (min-width: 768px) {
          grid-row: 2 / 3;
          grid-column: 1 / 2;
        }
      }
    }
  }

  .twitter {
    margin-top: 0 !important;
  }
}
</style>
